module.exports = __webpack_public_path__ + "img/Edge.4335faed.png";